<template>
  <generic-modal :title="$t('log')" ref="generic_modal">
    <div>
      <!-- <pre>{{ meta }}</pre> -->
      <div class="box" v-for="(message, index) in meta" :key="index">
        <div class="title has-text-weight-light is-7 mb-1">
          {{ format_date_time(message.date) }}
        </div>
        <p class="has-text-weight-semibold">{{ message.message }}</p>
        <div
          v-if="message.execution_result"
          class="is-family-monospace has-text-weight-light is-size-6"
        >
          {{ message.execution_result }}
        </div>
      </div>
      <!-- <div class="messages" ref="messages">
        <div v-for="(message, index) in meta" class="message" :key="index">
          <div class="message-body">
            <p>{{ message.message }}</p>
          </div>
        </div>
      </div> -->
    </div>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("close") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  format_date_time,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";

export default {
  name: "LogModal",
  components: { GenericModal },
  data() {
    return {
      meta: {},
      error: "",
    };
  },
  computed: {},
  methods: {
    format_date_time,
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal(uuid) {
      let v = this;
      v.set_initial_state();

      get("/dictamen/log", { uuid: uuid })
        .then((log) => {
          v.meta = log;
          v.$refs.generic_modal.show_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    set_initial_state() {
      let v = this;
      v.meta = {};
      v.error = "";
      // v.uuid = "";
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style>
.chat-box {
  max-height: 500px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.messages {
  flex-grow: 1;
  margin-bottom: 1rem;
  overflow-y: auto;
}

.message {
  margin-bottom: 0.5rem;
}

.message.is-user {
  text-align: right;
}

.message.is-user .message-body {
  background-color: #209cee;
  color: white;
  display: inline-block;
  padding: 0.5rem 1rem;
  border-radius: 8px;
}

.message.is-assistant .message-body {
  background-color: #00d1b2;
  color: black;
  display: inline-block;
  padding: 0.5rem 1rem;
  border-radius: 8px;
}
</style>
